module.exports = __webpack_public_path__ + "img/act-of-emotion-inspect-large.c9d1a2aa.jpg";